/**
 * Plugin client-side untuk membatasi aksi cetak pada halaman undangan.
 *
 * Tujuannya lebih ke UX dan proteksi ringan:
 * - mencegah shortcut print
 * - menonaktifkan menu konteks print
 * - mengganti perilaku `window.print`
 */
export default defineNuxtPlugin((nuxtApp) => {
  if (!nuxtApp.isHydrating) {
    return;
  }

  const toastNotification = useToastNotification();

  // Cegah shortcut cetak dari keyboard.
  window.addEventListener("keydown", (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === "p") {
      e.stopPropagation();
      e.preventDefault();
      e.stopImmediatePropagation();
      toastNotification.add("error", {
        description: "Tidak bisa mencetak halaman",
      });
    }
  });

  // Cegah menu konteks browser yang bisa mengarah ke aksi cetak.
  window.addEventListener("contextmenu", (e) => {
    e.preventDefault();
  });

  // Override API cetak browser agar semua jalur tetap konsisten menampilkan toast.
  window.print = () => {
    toastNotification.add("error", {
      description: "Tidak bisa mencetak halaman",
    });
    return false;
  };

  window.onbeforeprint = () => {
    toastNotification.add("error", {
      description: "Tidak bisa mencetak halaman",
    });
    return false;
  };

  window.onafterprint = () => {
    toastNotification.add("error", {
      description: "Tidak bisa mencetak halaman",
    });
    return false;
  };
});
